module.exports = __webpack_public_path__ + "static/img/FuLin_Banner_spring.d4081caa.jpg";